import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  visitTeachingCenter(where) {
    const op = {
      1: 'Home页-教学中心-查看全部',
      2: '左侧导航栏',
      3: '服务市场-了解更多'
    };
    buryPoint.event({
      action: '浏览教学中心-入口位置',
      eventCategory: '浏览教学中心',
      eventLabel: op[where]
    });
  },
  noTeachingVideo() {
    buryPoint.event({
      action: '教学中心搜索-搜索无结果',
      eventCategory: '搜索无结果'
    });
  },
  teachingCenterSearch() {
    buryPoint.event({
      action: '教学中心搜索-进行搜索',
      eventCategory: '教学中心搜索'
    });
  },
  openVideoLink(where, title) {
    const op = {
      1: 'Home页-教学中心卡片',
      2: '教学中心',
      3: '功能页入口'
    };
    buryPoint.event({
      action: '查看教学视频-入口位置',
      eventCategory: '查看教学视频',
      eventLabel: op[where]
    });
    buryPoint.event({
      action: '查看教学视频-查看信息',
      eventCategory: '查看教学视频',
      eventLabel: title
    });
  },
  TeachingCenterCard(where) {
    const op = {
      1: '热门',
      2: '最新',
      3: 'view all'
    };
    buryPoint.event({
      action: '教学中心卡片-按钮点击',
      eventCategory: '教学中心卡片',
      eventLabel: op[where]
    });
  },
  categorySelect(category) {
    const op = {
      1: 'Hik-ProConnect介绍',
      2: '设备添加与配置',
      3: '远程运维',
      4: '企业管理与购买',
      5: '健康监测与联动',
      6: '云考勤',
      7: '客流与测温'
    };
    buryPoint.event({
      action: '教学中心视频筛选-按类别筛选',
      eventCategory: '按类别筛选',
      eventLabel: op[category]
    });
  },
  labelSelect(label) {
    const op = {
      1: '推荐',
      2: '热门',
      3: '最新'
    };
    buryPoint.event({
      action: '教学中心视频筛选-按标签筛选',
      eventCategory: '按标签筛选',
      eventLabel: op[label]
    });
  },
  popoverShow() {
    buryPoint.event({
      action: '教学视频客户端切换-出现选择浮框',
      eventCategory: '出现选择浮框'
    });
  },
  popoverSelect(btn) {
    const op = {
      1: 'Portal',
      2: 'APP'
    };
    buryPoint.event({
      action: '教学视频客户端切换-客户端选择',
      eventCategory: '客户端选择',
      eventLabel: op[btn]
    });
  },
  HomeTabSelect(tab) {
    const op = {
      1: 'Portal',
      2: 'APP'
    };
    buryPoint.event({
      action: '教学视频客户端切换-播放窗口客户端切换',
      eventCategory: '播放窗口客户端切换',
      eventLabel: op[tab]
    });
  },
  openDocumentLink(where, title) {
    const op = {
      1: 'Home页-教学中心卡片',
      2: '教学中心',
      3: '功能页入口'
    };
    buryPoint.event({
      action: '查看教学文档-入口位置',
      eventCategory: '查看教学文档',
      eventLabel: op[where]
    });
    buryPoint.event({
      action: '查看教学文档-查看信息',
      eventCategory: '查看教学文档',
      eventLabel: title
    });
  },
  showQuestionnaire(where) {
    const op = {
      1: '教学中心-初次触发',
      2: '教学中心-第二次触发'
    };
    buryPoint.event({
      action: '功能问卷调研-出现问卷提示',
      eventCategory: '功能问卷调研',
      eventLabel: op[where]
    });
  },
  openQuestionnaire(where) {
    const op = {
      1: '教学中心-初次触发',
      2: '教学中心-第二次触发'
    };
    buryPoint.event({
      action: '功能问卷调研-点击“填写问卷"',
      eventCategory: '功能问卷调研',
      eventLabel: op[where]
    });
  },
  closeQuestionnaire(where) {
    const op = {
      1: '教学中心-初次触发',
      2: '教学中心-第二次触发'
    };
    buryPoint.event({
      action: '功能问卷调研-点击"稍后填写"',
      eventCategory: '功能问卷调研',
      eventLabel: op[where]
    });
  }
};
